import { intitialState, EventState } from '../state/event.state';
import { EventActions, POST_EVENT_SUCCESS, GET_SECURITY_EVENT_SUCCESS, CLEAR_EVENT } from '../actions/event.action';


export function EventReducer(state: EventState = intitialState, action: EventActions): EventState {
    switch (action.type) {
        case POST_EVENT_SUCCESS: {
            return {
                ...state,
                Event: action.payload
            };
        }

        case CLEAR_EVENT: {
            return {
                ...state,
                Event: null
            };
        }

        case GET_SECURITY_EVENT_SUCCESS: {
            return {
                ...state,
                SecurityEvent: action.payload
            };
        }

        default: return state;
    }
}
